import React, { useState, useEffect, Children, cloneElement } from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  tabContainer: {
    display: "flex",
    backgroundColor: "#ccc",
    borderRadius: "8px",
    overflow: "hidden",

    height: "32px",
    width: "fit-content",
    boxSizing: "border-box",

    display: "flex",
    alignItems: "center",

    backgroundColor: "#DCDCDC",
    borderRadius: "4px",

    padding: "1px",
  },
  fullwidth: {
    width: "100%",
  },
});

const TabSelector = ({ value, children, onChange, fullwidth = false, ...props }) => {
  const classes = useStyles();
  const childrenArray = Children.toArray(children);

  // Determine initial selected index from `value`, or default to first tab
  const getIndexByValue = (val) => childrenArray.findIndex((child) => child.props.value === val);

  const [internalIndex, setInternalIndex] = useState(value !== undefined ? getIndexByValue(value) : 0);

  const selectedIndex = value !== undefined ? getIndexByValue(value) : internalIndex;

  useEffect(() => {
    if (value !== undefined) {
      const idx = getIndexByValue(value);
      if (idx !== -1 && idx !== internalIndex) {
        setInternalIndex(idx);
      }
    }
  }, [value, childrenArray]);

  const handleTabClick = (index, val) => {
    if (value === undefined) setInternalIndex(index); // only update internal if uncontrolled
    if (onChange) onChange(val, index);
  };

  const enhancedTabs = childrenArray.map((child, index) =>
    cloneElement(child, {
      selected: index === selectedIndex,
      onClick: () => handleTabClick(index, child.props.value),
    })
  );

  return (
    <div
      className={`${classes.tabContainer} ${fullwidth ? classes.fullwidth : ""}`}
      {...props}
    >
      {enhancedTabs}
    </div>
  );
};

export default TabSelector;
